import Swal from "sweetalert2";

const SwalMessage = (props) => {
  // SwalMessage({ title: "yyyyyyyy", iSsuccess: false });
  // SwalMessage();
  // SwalMessage({ title: "yyyyyyyy" });


  return Swal.fire({
    position: "bottom-end",
    html: props?.html,
    reverseButtons: true,
    icon: props?.iSsuccess ? "success" : "error",
    title: props?.title,
    showConfirmButton: false,
    timer: props.timer ?? 2000,
  });
};

export default SwalMessage;
